import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Additive(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '0px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2 style={{whiteSpace:'normal'}}>Additive Manufacturing</h2>
                <li>
                    <Link to={`${url}/extrusion`}>Extrusion Printers</Link>
                </li>  
                <li>
                    <Link to={`${url}/keyparameters`}>Key Parameters</Link>
                </li>            
                <li>
                    <Link to={`${url}/resin`}>Resin Printing</Link>
                </li>
                <li>
                    <Link to={`${url}/sintering`}>Laser Sintering</Link>
                </li>    
                <li>
                    <Link to={`${url}/powder`}>Powder Adhesion</Link>
                </li>        
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Additive; 